export enum ActiveElementType {
  SITE = 'site',
  ASSET = 'asset',
  DEVICE = 'device'
}
